import { Link } from "react-router-dom";
import ContactCard from "./ContactCard";
import Icon from "./Icon";
import "./events.css";

const COPY = {
  cancelled: {
    heading: "This event was cancelled",
    body: "Unfortunately this event is no longer happening. We'd still love to help with your vehicle.",
  },
  paused: {
    heading: "Registration is paused",
    body: "Sign-ups for this event are paused for now. Please check back soon, or reach out to the shop directly.",
  },
  cutoff: {
    heading: "Registration has closed",
    body: "Registration for this event is now closed, but we'd still love to help.",
  },
};

const FALLBACK = {
  heading: "This event is no longer accepting registrations",
  body: "Thank you for your interest. We'd still love to help with your vehicle.",
};

const InactivePage = ({ event }) => {
  const { heading, body } = COPY[event.inactiveReason] || FALLBACK;
  const replacement =
    event.inactiveReason === "cancelled" && event.replacedByEventId;

  return (
    <div className="ev-wrap ev-wrap--narrow ev-confirm-center">
      <div className="ev-alert-badge">
        <Icon name="warn" size={34} color="var(--brand-persimmon)" />
      </div>
      <h1 className="ev-h1">{heading}</h1>
      <p className="ev-lead ev-lead--center">
        {event.name ? (
          <>
            Thank you for your interest in <strong>{event.name}</strong>. {body}
          </>
        ) : (
          body
        )}
      </p>

      {replacement && (
        <p className="ev-lead ev-lead--center ev-replacement">
          This event has been rescheduled.{" "}
          <Link to={`/events/${event.replacedByEventId}`}>
            See the new date
          </Link>
          .
        </p>
      )}

      <ContactCard shop={event.shop} />
    </div>
  );
};

export default InactivePage;
